exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".muti-instance .el-form-item {\n  margin-bottom: 0.114583rem;\n}", ""]);

// exports
